import { useCallback } from "react";

import type { MarkCaseReviewedResponse } from "../services/caseServiceV2.types";
import { useCaseService } from "./useCaseService";

type MarkCaseReviewedFn = (caseId: string) => Promise<MarkCaseReviewedResponse>;

export const useMarkCaseReviewed = (): MarkCaseReviewedFn => {
  const caseServiceV2 = useCaseService();
  return useCallback(
    (caseId: string): Promise<MarkCaseReviewedResponse> => caseServiceV2.markCaseReviewed(caseId),
    [caseServiceV2]
  );
};
